import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  memberStateExcludeCyprusList: any;
  RemindersMsconReceivedList: {
    status: StateStatus | null;
    data: any;
  };
  unreadNotificationCount: {
    status: StateStatus | null;
    data: number;
  };
}

const initialState: IState = {
  memberStateExcludeCyprusList: {
    status: null,
    data: null,
  },
  RemindersMsconReceivedList: {
    status: null,
    data: null,
  },
  unreadNotificationCount: {
    status: null,
    data: 0,
  },
};

const RemindersMsconReceivedListReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS:
      return {
        ...state,
        memberStateExcludeCyprusList: {
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_VAT_RETURN_RECEIVED_LIST:
      return {
        ...state,
        RemindersMsconReceivedList: {
          ...state.RemindersMsconReceivedList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.RemindersMsconReceivedList.data
              : action.data,
        },
      };
    case Types.SET_UNREAD_NOTIFICATION_COUNT:
      return {
        ...state,
        unreadNotificationCount: {
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.unreadNotificationCount.data
              : action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default RemindersMsconReceivedListReducer;

/**
 * Add new Page Steps:
 *
 * navigation -> config -> index.tsx
 * navigation -> config -> Routes.tsx
 *
 */
